import { CONFIG } from 'src/config-global';
import { paths } from 'src/routes/paths';
import { removeLastSlash } from 'src/routes/utils';

import type { UserType } from '../types';

/** Only allow same-origin path redirects (blocks //evil.com, javascript:, backslash normalization, etc.). */
export function safeReturnToPath(raw: string | null, fallback: string): string {
  if (raw == null || raw === '') {
    return fallback;
  }
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('://') || raw.includes('\\')) {
    return fallback;
  }
  return raw;
}

export function isUserEmailVerified(user: UserType | { isEmailVerified?: boolean } | null | undefined): boolean {
  if (!user) {
    return true;
  }
  return user.isEmailVerified === true;
}

export const EMAIL_VERIFICATION_ALLOWED_PATHS = [
  paths.auth.jwt.verifyEmailPending,
  paths.auth.jwt.verify,
  paths.auth.jwt.verifyExternal,
] as const;

export function isEmailVerificationAllowedPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  const normalizedPath = removeLastSlash(pathname);
  return EMAIL_VERIFICATION_ALLOWED_PATHS.some(
    (allowedPath) => normalizedPath === allowedPath
  );
}

type PostAuthUser = {
  client?: Record<string, unknown> | null;
  isEmailVerified?: boolean;
};

export function getPostAuthRedirectPath(
  user: PostAuthUser,
  returnTo: string | null
): string {
  if (!isUserEmailVerified(user)) {
    return paths.auth.jwt.verifyEmailPending;
  }

  if (
    user.client &&
    Object.keys(user.client).length > 0 &&
    user.client.constructor === Object
  ) {
    return safeReturnToPath(returnTo, CONFIG.auth.redirectPath);
  }

  return paths.dashboard.createCompanyName.root;
}

export function isVerifyEmailPendingPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }
  return removeLastSlash(pathname) === paths.auth.jwt.verifyEmailPending;
}
